// todo: remove draftjs usages in export

interface RawDraftContentBlock {
  key: string
  type: BlockType
  text: string
  depth: number
}

interface ContentBlock {
  getType(): BlockType
}

interface RawDraftContentState {
  blocks: RawDraftContentBlock[]
}

enum BlockType {
  UNSTYLED = 'unstyled',
  BLOCKQUOTE = 'blockquote',
  LEAD = 'lead',
  BULLETINS_LIST = 'unordered-list-item',
  H1 = 'header-one',
  H2 = 'header-two',
  H3 = 'header-three',
  NUMERIC_LIST = 'ordered-list-item',
  TODO = 'checkable-list-item',
  CODE = 'code-block',
}

const TEXT_BLOCK = new Set<BlockType>([
  BlockType.UNSTYLED,
  BlockType.BLOCKQUOTE,
  BlockType.LEAD,
  BlockType.CODE,
  BlockType.BULLETINS_LIST,
  BlockType.NUMERIC_LIST,
  BlockType.TODO,
  BlockType.H1,
  BlockType.H2,
  BlockType.H3,
])

const isTextBlock = (blockOrRawBlock: ContentBlock | RawDraftContentBlock) => {
  const type =
    'type' in blockOrRawBlock
      ? blockOrRawBlock.type
      : 'getType' in blockOrRawBlock &&
          typeof blockOrRawBlock.getType === 'function'
        ? blockOrRawBlock.getType()
        : BlockType.UNSTYLED

  return TEXT_BLOCK.has(type as BlockType)
}

export const getInlineContext = (value?: string | null): string => {
  // The type promises a draft.js string, but the same fields also carry editor
  // values from the API — those belong to getBlockContentText, not here.
  if (!value || typeof value !== 'string') {
    return ''
  }

  try {
    const parsed: RawDraftContentState = JSON.parse(value)
    if (!parsed || !parsed.blocks || !Array.isArray(parsed.blocks)) {
      return ''
    }

    const resultArr = parsed.blocks.filter((block) => isTextBlock(block))

    return resultArr.map((item) => item.text).join('\n')
  } catch (e) {
    return value
  }
}
